.notScoredGray {
    filter: grayscale(100%);
}

.showNonUsedCheckbox {
    position: absolute;
    top: 22px;
    right: 0px;
    margin-right: 20px;
    margin-top: 20px;
    z-index: 50000;
}

.sectionIcon {
    img {
        width: 32px;
        height: 32px;
        filter: brightness(0) saturate(100%) invert(79%) sepia(7%) saturate(495%) hue-rotate(14deg) brightness(96%) contrast(90%);
    }

    margin-right: 8px;
    object-fit: contain;
    display: inline-block;
}

.panelTableStyle {
    grid-template-columns: 320px 1fr 130px 130px !important;
    padding-top: 4px !important;
    --panel-table-gap: 7px;
    //--panel-table-auto-row-width: minmax(auto, 600px);
    //--panel-table-label-column-width: 500px;

    > [class*='headerRow'] {
        background-color: #fcfcfd;
        //background-color: red !important;
        text-align: center;
        border: none !important;
        height: 30px;
        padding-top: 10px !important;
        padding-bottom: 30px !important;
    }
    [class*='grid_col_2']:not(*[class*='headerRow']) {
        & > div {
            transform: translateY(5px);
        }
    }

    [class*='grid_col_1'] {
        &:not(*[class*='headerRow']) > div {
            transform: translateY(0px);
            justify-content: start !important;
        }
    }

    [class*='grid_col_3'],
    [class*='grid_col_4'] {
        &:not(*[class*='headerRow']) > div {
            transform: translateY(-18px);
        }
    }

    > [class*='grid_row_2'] {
        padding-top: 10px !important;
    }

    > [class*='grid_item'] {
        background-color: #fcfcfd;
        border: none;
        border-bottom: 1px dashed #bfc1c3;
        padding-top: 30px;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }

    *[class*='rowValue'] {
        text-align: center;
    }
}

.noDataAvail {
    font-size: 20px;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #102442;
    text-align: center;
    padding: 10px;
}

.dealThumbScore {
    position: absolute;
    top: -20;
}

.panelTableCompanies {
    *[class*='grid_row_1 '] {
        background-color: transparent !important;
    }
}

.companyLogo {
    width: 60%;
    max-height: 80px;
    object-fit: contain;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3));
}
.companyHeaderElement {
    background-color: white;
    border-radius: 20px;
    height: 200px;
    width: calc(100% - 40px);
    margin: 20px 20px;

    padding-top: 40px;
    padding-bottom: 30px;
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));
}

.companyNameLabel {
    font-size: 20px;
    font-family: LustTextMedium;
    color: black;
}

.panelTitleText {
    font-size: 28px !important;
    font-style: italic !important;
    font-weight: 500 !important;
    font-family: 'Lust Text', serif !important;
    color: #475467 !important;
    text-align: left !important;
}
.panelTitle {
    padding-top: 40px !important;
    padding-bottom: 15px !important;
    background-color: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    position: relative !important;

    &:not(:first-child)::before {
        content: '';
        position: absolute;
        top: 20px;
        left: 0;
        right: 0;
        height: 1px;
        background-image: linear-gradient(
            to right,
            black 33%,
            rgba(255, 255, 255, 0) 0%
        );
        background-position: top;
        background-size: 10px 1px;
        background-repeat: repeat-x;
        z-index: 1;
    }
    
    &:first-child {
        padding-top: 20px !important;
    }
}
